"use client";

import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { starFieldBackgroundProps } from "@/ui/world-tour/constants";
import { cn } from "@/lib/utils";
const StarFieldBackground: FC<{
  height: number;
}> = t0 => {
  const $ = _c(6);
  const {
    height
  } = t0;
  const t1 = `${height}px`;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      height: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("relative right-1/2 left-1/2 -mx-[50vw] w-screen h-full");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className={t3} role="img" xmlns="http://www.w3.org/2000/svg">{starFieldBackgroundProps.map(_temp)}</svg>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2) {
    t5 = <div className="absolute w-full" style={t2}>{t4}</div>;
    $[4] = t2;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
StarFieldBackground.displayName = "StarFieldBackground";
export default StarFieldBackground;
function _temp(star, index) {
  return <circle key={index} cx={star.cx} cy={star.cy} r={star.r} fill="#ffffff" className="animate-twinkle" style={{
    animationDelay: star.animationDelay
  }} />;
}